import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-film-line text-xl" />
              </span>
              <span className="text-lg font-bold text-background-50">肮脏的交易</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              肮脏的交易是一个专注影视作品资讯与剧情解析的门户平台。我们提供最新影视资讯、详细剧情介绍与角色分析，帮助影迷快速了解作品卖点与细节，提升每一次观影体验。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200">
                <i className="ri-wechat-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200">
                <i className="ri-weibo-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200">
                <i className="ri-mail-line" />
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <Link to="/" className="cursor-pointer hover:text-accent-400">
                内容导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-300 hover:text-accent-400 cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-background-300 hover:text-accent-400 cursor-pointer">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-background-300 hover:text-accent-400 cursor-pointer">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-300 hover:text-accent-400 cursor-pointer">
                  影视搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 hover:text-accent-400 cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <Link to="/about" className="cursor-pointer hover:text-accent-400">
                联系我们
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5" />
                <span>contact@dirtydeal-media.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5" />
                <span>北京市朝阳区文化创意园 A 座 12 层</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5" />
                <span>周一至周五 09:00 - 18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 肮脏的交易 影视资讯. 保留所有权利。</p>
          <p className="text-background-400">
            本站影视作品信息均为虚构示例，仅用于内容展示与演示用途。
          </p>
        </div>
      </div>
    </footer>
  );
}